import React, { useMemo } from 'react';
import { format } from 'date-fns';

import { mapToPluralForm } from '@crm-framework/utils';

import { shortDateTimeFormat } from '@crm-package/app';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { getDealsIdComponent } from './utils';

interface IManager {
  dealIds: string[];
  dealsCount: number;
  leadsCount: number;
  isTeamManager: boolean;
  managerFullName: string;
  managerId: number;
}

const getManagersDealsComponent = (managers: IManager[]) => (
  <>
    {managers.map(
      ({ dealIds, dealsCount, leadsCount, managerFullName, managerId }) => {
        const leadText = mapToPluralForm(leadsCount, 'client');
        const dealText = mapToPluralForm(dealsCount, 'deal');
        const DealIdsComponent = getDealsIdComponent(dealIds);

        return (
          <React.Fragment key={managerId}>
            <div>
              <strong>Manager ID:</strong>
              {` ${managerId}, ${managerFullName}. `}
              <strong>{`${dealText} `}</strong>
              from
              <strong>{` ${leadText}. `}</strong>
            </div>
            <div>
              <strong>Deals IDs:</strong>
              {DealIdsComponent}
            </div>
          </React.Fragment>
        );
      }
    )}
  </>
);

export const ExpiringDealsForTMDetails: React.FC<INotificationGridItem> = ({
  notificationDetails,
  date,
}) => {
  const { dealsTotalCount, leadsTotalCount, dateFrom, dateTo, managers } =
    notificationDetails.data;
  const validDateTo = format(new Date(dateTo), shortDateTimeFormat);
  const validDateFrom = format(new Date(dateFrom), shortDateTimeFormat);
  const DealsComponent = useMemo(
    () => getManagersDealsComponent(managers),
    [date]
  );

  return (
    <>
      <DetailsRow label="Total deals count" value={dealsTotalCount} />
      <DetailsRow label="Total leads count" value={leadsTotalCount} />
      <DetailsRow label="Valid date from" value={validDateFrom} />
      <DetailsRow label="Valid date to" value={validDateTo} />
      <DetailsRow label="Deals" component={DealsComponent} />
    </>
  );
};
